// Implement more logic here

import React from "react";
import { array, object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { DfpComponent } from "../../ads/dfp-component";
import { StoryGrid } from "../../story-grid";

import "./four-col-grid.m.css";

export function FourColGrid({ collection, stories, customSectionTemplate = false }) {
  const currPath = useSelector((state) => get(state, ["qt", "currentPath"], ""))
    .split("?")[0]
    .split("/")[1];
  const pageName = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_name_mapping", currPath], "sections")
  );
  const networkId = useSelector((state) => get(state, ["qt", "config", "ads-config", "network_id"], ""));
  const bottomAdUnit = `/${networkId}/GULFNEWS/Gulfnews_BTF/gulfnews_${pageName}_btf/gulfnews_${pageName}_btf_footer`;

  const adConfig3 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_3"], {})
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));

  return (
    <div styleName={customSectionTemplate ? "four-col-grid-container" : "row-component"}>
      {!customSectionTemplate && <h2 styleName="heading">{collection?.name}</h2>}
      <StoryGrid stories={stories} customSectionTemplate={customSectionTemplate} styleName="four-col-story-grid" />
      <div styleName="bottom-ad-container">
        <DfpComponent
          adStyleName="ad-slot-size-970x250"
          id={`${pageType}-listing-${collection?.slug}-ad`}
          path={bottomAdUnit}
          size={adConfig3.sizes}
          viewPortSizeMapping={adConfig3.view_port_size_mapping}
        />
      </div>
    </div>
  );
}

FourColGrid.propTypes = {
  collection: object,
  stories: array,
};

FourColGrid.storyLimit = 8;
FourColGrid.nestedCollectionLimit = [1, 2, 3];
